// Onboarding's queries. The invitation preview is public; the sign-in probe asks `/me` outside the query cache's
// error routing, so a signed-out visitor stays on the invitation instead of being sent to sign-in.
import { ApiError } from '@orca/api-client'
import { queryOptions } from '@tanstack/react-query'
import { api } from '../../shared/api/api'

export const invitationPreviewQuery = (code: string) =>
  queryOptions({
    queryKey: ['invitation', code] as const,
    queryFn: async ({ signal }) => {
      try {
        return (await api.GET('/invitations/{code}', { params: { path: { code } }, signal })).data ?? null
      } catch (error) {
        if (error instanceof ApiError && error.status === 404) return null
        throw error
      }
    },
    staleTime: 30_000,
  })

export const signedInQuery = () =>
  queryOptions({
    queryKey: ['invitation', 'signed-in'] as const,
    queryFn: async ({ signal }) => {
      try {
        return Boolean((await api.GET('/me', { signal })).data)
      } catch {
        return false
      }
    },
    staleTime: 0,
  })
